export default "__VITE_PUBLIC_ASSET__772f6f11__"